import React from 'react';
import { cn } from '../../lib/utils';

export function SectionEyebrow({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <span className={cn('text-[10px] font-black uppercase tracking-widest text-muted-foreground/70', className)}>
      {children}
    </span>
  );
}

export function DescriptionText({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <p className={cn('text-xs text-muted-foreground leading-relaxed', className)}>
      {children}
    </p>
  );
}

export function TechnicalValue({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <span className={cn('font-mono text-[11px] text-muted-foreground/80', className)}>
      {children}
    </span>
  );
}
